module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Workplaces', // Navigation and Site Title
  siteTitleAlt: 'Workplaces', // Alternative Site title for SEO
  siteUrl: 'https://workplaces.underdog.io', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
  siteDescription: 'unsponsored documentary profiles of business and culture.',
//  siteFBAppID: '', // Facebook App ID - Optional
};



// WEBPACK FOOTER //
// ./config/website.js